import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";

const ChartDialog = ({ open, onClose, title, rows, columns }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textTransform: "uppercase",
        fontWeight: "bold",
      }}
    >
      {title}
      <IconButton onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Box
        sx={{
          height: 400,
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "#f9f9f9",
          },
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#ffffff",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f4f4f4", // Light background for headers
            fontWeight: "bold", // Make headers bold
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold", // Additional bold styling
          },
        }}
      >
        <DataGrid
          columnHeaderHeight={30}
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
          disableSelectionOnClick
          rowHeight={20} // Adjust row height
        />
      </Box>
    </DialogContent>
  </Dialog>
);

export default ChartDialog;
